class AppConfig {
  getBaseUrl(): string {
    const baseUrl = "https://api-smbserver.lirisoft.net/api/";
    return baseUrl;
  }
}

const appConfig = new AppConfig();

export default appConfig;
